<template>
    <div class="layer">
        <div class="wrap">
            <HeaderLayout></HeaderLayout>
            <div class="content">
                <button type="button" class="in_back_btn" @click="router.replace('/')">
                    <img src="@/assets/user/line_back_ico_l.png" />
                    <span>BACK</span>
                </button>
                <p class="page_title">마이 페이지</p>
                <div class="my_pg_wrap">
                    <ul class="my_pg_menu">
                        <li>
                            <router-link to="#">
                                <div class="mp_tit">
                                    <span class="ico"><img src="@/assets/user/my_ico1.png" /></span>
                                    <p>메타헬스와 함께한 일자</p>
                                </div>
                                <span class="count">{{ numberFormat(state.cntDaysFromJoin) + " 일" || "값이 없습니다" }}</span>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="#">
                                <div class="mp_tit">
                                    <span class="ico"><img src="@/assets/user/my_ico2.png" /></span>
                                    <p>메타헬스로 수집한 정보</p>
                                </div>
                                <span class="count">{{ state.cntAlarm + " 건" || "값이 없습니다" }}</span>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="#">
                                <div class="mp_tit">
                                    <span class="ico"><img src="@/assets/user/my_ico3.png" /></span>
                                    <p>평균 스트레스 지수</p>
                                </div>
                                <span class="count">{{ state.stress + " 점" || "값이 없습니다" }}</span>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="#">
                                <div class="mp_tit">
                                    <span class="ico"><img src="@/assets/user/my_ico4.png" /></span>
                                    <p>평균 피로도 지수</p>
                                </div>
                                <span class="count">{{ state.fatigue + " 점" || "값이 없습니다" }}</span>
                            </router-link>
                        </li>
                    </ul>
                    <router-link to="#" class="survey_box" @click="checkCntSurvey">
                        <div class="mp_tit2">
                            <img src="@/assets/user/my_ico5.png" />
                            <span>설문조사</span>
                        </div>
                        <div>
                            <span class="count">{{ state.cntSurvey }}건</span>
                            <img src="@/assets/user/c_arrow_r.png" />
                        </div>
                    </router-link>
                    <div class="my_pg_btns">
                        <router-link to="/userModify" class="my_pg_btn1">
                            <img src="@/assets/user/my_ico6.png" />
                            <span>내정보수정</span>
                        </router-link>
                        <router-link to="/passwordModify" class="my_pg_btn2">
                            <img src="@/assets/user/my_ico7.png" />
                            <span>비밀번호 변경</span>
                        </router-link>
                        <router-link to="#" class="my_pg_btn3">
                            <img src="@/assets/user/my_ico8.png" />
                            <span>알림 주기 설정</span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <GnbLayout></GnbLayout>
    <ModalComponent :show="state.isModalOpen" :no="''" :content="modal.content" @close="modalClose">
    </ModalComponent>
</template>
<script lang="ts">
import {
    ModalComponent,
    HeaderLayout,
    GnbLayout,
    apiService,
    onMounted,
    reactive,
    router,
    userStore,
    numberFormat,
    globalStore,
} from "@/BaseComponent";

export default {
    components: {
        ModalComponent,
        HeaderLayout,
        GnbLayout,
    },
    setup() {
        const user = userStore();
        const global = globalStore();
        const state = reactive({
            cntDaysFromJoin: 0 as number,
            cntAlarm: 0 as number,
            stress: 0 as number,
            fatigue: 0 as number,
            cntSurvey: 0 as number,
            isModalOpen: false as boolean,
        });
        const modal = reactive({
            content: "" as string,
            confirm: "" as string,
            cancel: "" as string,
            actionCode: 0 as number
        });
        onMounted(() => {
            global.setSelectMenu("mypage");
            getUserInfo();
        });

        const getUserInfo = async () => {
            const res = await apiService.member.getInfo();
            if (res.returnCode === 0) {
                if (res.data.fatigue) state.fatigue = res.data.fatigue;
                if (res.data.cntAlarm) state.cntAlarm = res.data.cntAlarm;
                if (res.data.stress) state.stress = res.data.stress;
                if (res.data.cntDaysFromJoin) state.cntDaysFromJoin = res.data.cntDaysFromJoin;
                if (res.data.cntSurvey) state.cntSurvey = res.data.cntSurvey;
            } else if (res.returnCode === 11) {
                modal.content = "토큰이 만료되었습니다<br>로그인을 다시해주세요";
                state.isModalOpen = true;
            }
        };

        const modalClose = (result: boolean) => {
            state.isModalOpen = false;
        };

        const checkCntSurvey = (e: any) => {
            e.preventDefault();
            if (state.cntSurvey === 0 || state.cntSurvey === undefined || state.cntSurvey === null) {
                modal.content = "참여가능한 설문이 없습니다.";
                state.isModalOpen = true;
            } else {
                router.push("/survey/list");
            }
        };

        return {
            user,
            state,
            modal,
            router,
            modalClose,
            checkCntSurvey,
            numberFormat
        };
    },
};
</script>
<style scoped>
.myGrid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    line-height: 25px;
}

.myGrid>div {
    border: 1px solid;
}

.test_btn {
    padding-top: 10px;
}

.test_btn>a {
    border: 1px solid;
    margin: 5px;
}
</style>
